<template>
    <div>
        <div class="expiry-data d-flex justify-content-between align-items-center flex-wrap mb-3">
            <h2 class="text-left mb-0">{{ $t('citations.title') }}</h2>
            <div class="d-flex justify-content-between justify-content-sm-center flex-wrap" v-if="allowAddRecord">
                <b-button class="export equipment d-flex justify-content-center align-items-center mx-1 my-1 w-fit-content"
                    variant="primary" @click="allowAddCitation = true">
                    <b-icon icon="plus" aria-hidden="true"></b-icon>
                    <p class="mb-0 ml-2 text-white">{{ $t('citations.addCitation') }}</p>
                </b-button>
            </div>
        </div>
        <div class="data-table team-data-table bg-white rounded table-custom-border">
            <div class="bg-white pt-3 pt-sm-4 rounded">
                <div class="table_row">
                    <div class="filter-box" v-if="isTableMounted">
                        <div class="d-flex mb-4 px-3 px-sm-4">
                            <b-form-group class="text-left label font-weight-normal search-field mb-0">
                                <b-input-group class="username-input-field">
                                    <b-form-input type="text" :placeholder="$t('safetyShared.search')"
                                        v-model="filterFields.search" class="unit f-12"
                                        @keyup.enter="getCitationData()"></b-form-input>
                                    <b-input-group-append>
                                        <b-button variant="primary" @click="getCitationData()">
                                            <svg width="14" height="15" viewBox="0 0 14 15" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M6.14286 11.7857C8.98318 11.7857 11.2857 9.48318 11.2857 6.64286C11.2857 3.80254 8.98318 1.5 6.14286 1.5C3.30254 1.5 1 3.80254 1 6.64286C1 9.48318 3.30254 11.7857 6.14286 11.7857Z"
                                                    stroke="white" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path d="M10 10.5L13 13.5" stroke="white" stroke-width="2"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                            <div class="ml-auto align-items-center d-none d-sm-flex flex-wrap">
                                <div class="position-relative">
                                    <div class="position-absolute notification-badge" v-if="activeFiltersCount">
                                        {{ activeFiltersCount }}
                                    </div>
                                    <button class="btn btn-filter-section" @click="$bvModal.show('modal-filter')">
                                        <div class="d-flex align-items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="lucide lucide-sliders-horizontal w-4 h-4" data-id="element-964">
                                                <line x1="21" x2="14" y1="4" y2="4"></line>
                                                <line x1="10" x2="3" y1="4" y2="4"></line>
                                                <line x1="21" x2="12" y1="12" y2="12"></line>
                                                <line x1="8" x2="3" y1="12" y2="12"></line>
                                                <line x1="21" x2="16" y1="20" y2="20"></line>
                                                <line x1="12" x2="3" y1="20" y2="20"></line>
                                                <line x1="14" x2="14" y1="2" y2="6"></line>
                                                <line x1="8" x2="8" y1="10" y2="14"></line>
                                                <line x1="16" x2="16" y1="18" y2="22"></line>
                                            </svg>
                                            <p class="mb-0 ml-2">{{ $t('safetyShared.filters') }}</p>
                                        </div>
                                    </button>
                                </div>
                                <div class="table-columns-section ml-2 mt-0" @click="showColumns = true">
                                    <button class="btn btn-table-columns-section">
                                        <div class="d-flex align-items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="lucide lucide-columns2 w-4 h-4" data-id="element-961">
                                                <rect width="18" height="18" x="3" y="3" rx="2"></rect>
                                                <path d="M12 3v18"></path>
                                            </svg>
                                            <p class="mb-0 ml-2">{{ $t('safetyShared.columns') }}</p>
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="!isTableMounted" class="mt-2" style="height: calc(100vh - 180px); overflow: hidden;">
                        <b-skeleton-table :rows="17" :columns="7"
                            :table-props="{ hover: true, responsive: true }"></b-skeleton-table>
                    </div>
                    <b-table v-else class="mt-2" responsive :fields="visibleFields" :items="items" hover
                        :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                        :no-local-sorting="true" :busy.sync="isBusy" :sticky-header="'calc(100vh - 273px)'"
                        :show-empty="emptyTable">
                        <template #cell(notes)="data">
                            <v-app v-if="data.value">
                                <v-tooltip top>
                                    <template #activator="{ on, attrs }">
                                        <span class="w-fit-content item-description text-left" v-on="on" v-bind="attrs">{{
                                            data.value
                                        }}</span>
                                    </template>{{ formatTooltipText(data.value) }}
                                </v-tooltip>
                            </v-app>
                            <p v-else>-</p>
                        </template>
                        <template #cell(last_note)="data">
                            <v-app v-if="data.value" class="d-contents align-items-center">
                                <v-tooltip bottom>
                                    <template #activator="{ on, attrs }">
                                        <span
                                            class="w-fit-content item-description text_primary text-left maxw-200px cursor-pointer"
                                            @click.stop="editNote(data.item)" v-on="on" v-bind="attrs">{{
                                                htmlToPlainText(data.value) }}</span>
                                    </template>
                                    <div class="note-tooltip-content">{{ htmlToPlainText(data.value) }}</div>
                                </v-tooltip>
                            </v-app>
                            <span v-else class="d-flex text_primary cursor-pointer" @click.stop="editNote(data.item)">-
                            </span>
                        </template>
                        <template #cell(record_no)="data">
                            <p class="mb-0 cursor-pointer text_primary mb-0"
                                @click="citationID = data.item.id; pendingTab = 0" v-if="allowViewRecord">{{
                                    data.value }}</p>
                            <p class="mb-0" v-else>{{ data.value }}</p>
                        </template>
                        <template #cell(status)="data">
                            <b-button class="btn f-14 pe-none d-flex justify-content-center align-items-center"
                                :variant="data.item.status === 'New' ? 'warning-status' : data.item.status === 'Urgent' ? 'danger-status' : data.item.status === 'Open' ? 'success-status' : 'secondary-status'">
                                <p class="mb-0">{{ data.value }}</p>
                            </b-button>
                        </template>
                    </b-table>
                    <div class="entries-pagination px-0 px-sm-2" v-if="isTableMounted">
                        <div class="d-flex align-items-center flex-wrap">
                            <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                                <b-form-select v-model="perPage" :options="pageOptions" />
                            </div>
                            <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">{{ positionText }}</p>
                            <div class="pagination">
                                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                                    aria-controls="my-table"></b-pagination>
                            </div>
                        </div>
                    </div>
                    <AddCitation @close="allowAddCitation = false" :allowAddCitation="allowAddCitation" :states="states"
                        @citationAdded="getCitationNewData($event)" />
                    <EditCitation :states="states" :citationID="citationID" @resetEditCitation="citationID = null"
                        @citationUpdated="getCitationData()" :initialTab="pendingTab" />
                    <TableColumns :showColumns="showColumns" :fields="fields"
                        @getUpdatedFieldsList="getUpdatedFieldsList($event)" @updateFields="updateFields($event)"
                        @resetTableFields="resetTableFields()" @resetData="showColumns = false" />
                    <b-modal id="modal-filter" centered no-close-on-backdrop :footer-class="'d-block p-3 m-0'"
                        :body-class="'px-3 pt-3 pb-1'" no-close-on-esc>
                        <template #modal-header="{ close }">
                            <h5 class="modal-title">
                                {{ $t('safetyShared.filters') }}
                            </h5>
                            <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                                Close Modal
                            </b-button>
                        </template>
                        <div class="body">
                            <b-form-group :label="$t('claims.filterStatus')" class="text-left select_arrow label mb-3">
                                <b-form-select v-model="filterFields.status" type="text" class="input f-12"
                                    :options="statusFilterOptions" @change="getCitationData()"></b-form-select>
                            </b-form-group>
                            <b-form-group :label="$t('teamPage.filterDivision')" class="text-left w-equipment-box">
                                <v-select multiple :options="allDivisions" class="f-12" :reduce="(option) => option.id"
                                    v-model="filterFields.division" @input="getCitationData()" />
                            </b-form-group>
                        </div>
                        <template #modal-footer="">
                            <div class="text-right modal-footer border-0 p-0 mb-0 mt-0 justify-content-between mx-0">
                                <b-button class="mx-0 mb-0 h-40px w-100px m-0 btn-outline-primary" variant="primary"
                                    @click="resetFilterFields(); $bvModal.hide('modal-filter')">{{ $t('safetyShared.reset')
                                    }}</b-button>
                                <b-button class="mx-0 h-40px w-100px m-0 m-0" block
                                    @click="$bvModal.hide('modal-filter')">{{ $t('safetyShared.close') }}</b-button>
                            </div>
                        </template>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import * as moment from "moment-timezone";
import AddCitation from './AddCitation.vue';
import EditCitation from "./EditCitation.vue"
import TableColumns from "@/components/Shared/TableColumns.vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
    components: { AddCitation, EditCitation, TableColumns, vSelect },
    props: ["states"],
    name: "Citations",
    data() {
        return {
            showColumns: false,
            allowAddCitation: false,
            pendingTab: 0,
            filterFields: {
                search: '',
                type: '',
                status: '',
                division: []
            },
            fields: [],
            items: [],
            isBusy: false,
            isTableMounted: false,
            emptyTable: false,
            sortBy: undefined,
            sortDesc: undefined,
            currentPage: 1,
            citationID: null,
            rows: 0,
            perPage: 10,
            positionText: "",
            pageOptions: [
                {
                    value: 10,
                    text: "10",
                },
                {
                    value: 25,
                    text: "25",
                },
                {
                    value: 50,
                    text: "50",
                },
                {
                    value: 100,
                    text: "100",
                },
            ],
        }
    },
    computed: {
        ...mapGetters(['rolePermissions', 'user', 'userPreferences', 'divisions']),
        statusFilterOptions() {
            return [
                { value: '', text: '' },
                { value: 'New', text: this.$t('safetyShared.statusNew') },
                { value: 'Open', text: this.$t('safetyShared.statusOpen') },
                { value: 'Closed', text: this.$t('safetyShared.statusClosed') },
                { value: 'Urgent', text: this.$t('safetyShared.statusUrgent') },
            ];
        },
        typeFilterOptions() {
            return [
                { value: '', text: '' },
                { value: 'Self', text: this.$t('editClaim.typeSelf') },
                { value: 'Insurance', text: this.$t('editClaim.typeInsurance') },
                { value: 'Other', text: this.$t('editClaim.typeOther') },
                { value: 'AL', text: 'AL' },
                { value: 'Cargo', text: 'Cargo' },
                { value: 'GL', text: 'GL' },
                { value: 'PD', text: 'PD' },
                { value: 'OO PD', text: 'OO PD' },
                { value: 'OO NTL', text: 'OO NTL' },
                { value: 'OccAcc', text: 'OccAcc' },
                { value: 'W.C.', text: 'W.C.' }
            ];
        },
        allowAddRecord() {
            return this.rolePermissions && this.rolePermissions['Safety'] && this.rolePermissions['Safety'][2].allow
        },
        allowViewRecord() {
            return this.rolePermissions && this.rolePermissions['Safety'] && this.rolePermissions['Safety'][0].allow
        },
        activeFiltersCount() {
            return Object.keys(this.filterFields).reduce((count, key) => {
                if (key === 'division') {
                    return count + (this.filterFields.division.length > 0 ? 1 : 0);
                }
                else if (
                    this.filterFields[key] !== '' &&
                    this.filterFields[key] !== null
                ) {
                    return count + 1;
                }
                return count;
            }, 0);
        },
        visibleFields() {
            return this.fields.filter(field => field?.visible)
        },
        allDivisions() {
            return this.divisions.map((item) => {
                return {
                    id: item.id,
                    label: item.division,
                }
            })
        },
    },
    methods: {
        ...mapActions(['getAllCitations', 'updateUserPreferences', 'deleteUserPreferences', 'setLoader']),
        editNote(item) {
            this.pendingTab = 2;
            this.citationID = item.id;
        },
        htmlToPlainText(htmlString) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = htmlString;
            return tempDiv.textContent || tempDiv.innerText || '';
        },
        async updateFields(updatedFields) {
            this.fields = updatedFields
            this.filterFields = {
                search: '',
                type: '',
                status: '',
                division: []
            }
            try {
                await this.updateUserPreferences({
                    "columns": updatedFields
                })
                await this.getCitationData()
            }
            catch (e) {
                console.log(e)
            }
        },
        async getUpdatedFieldsList(updatedFields) {
            this.fields = updatedFields
            try {
                const updatedOrderList = updatedFields.map((item, index) => {
                    return { ...item, display_order: index + 1 }
                })
                await this.updateUserPreferences(
                    {
                        "columns": updatedOrderList
                    })
            }
            catch (e) {
                console.log(e)
            }
        },
        async getCitationNewData(id) {
            await this.getCitationData()
            if (id) this.citationID = id
            this.allowAddCitation = false
        },
        formatTooltipText(text) {
            const maxLineLength = window.screen.width <= 767 ? 50 : 80;
            let formattedText = "";
            let lineLength = 0;

            text.split(' ').forEach(word => {
                if (lineLength + word.length + 1 > maxLineLength) {
                    formattedText += "\n";
                    lineLength = 0;
                }
                formattedText += (lineLength === 0 ? "" : " ") + word;
                lineLength += word.length + 1;
            });

            return formattedText;
        },
        async resetTableFields() {
            try {
                this.setLoader(true)
                await this.deleteUserPreferences(`Tickets/`)
                this.showColumns = false
                this.setLoader(false)
            }
            catch (e) {
                this.setLoader(false)
                console.log(e)
            }
        },
        async resetFilterFields() {
            this.filterFields = {
                search: '',
                type: '',
                status: '',
                division: []
            },
                await this.getCitationData();
        },
        async getCitationData() {
            try {
                this.items = []
                this.isBusy = true
                let url = ""
                let tags = ""
                if (this.$route.query.recordNo) {
                    this.filterFields.search = this.$route.query.recordNo
                }
                Object.keys(this.filterFields).map((key) => {
                    if (this.filterFields[key] && key != 'division') {
                        url += `${key}=${this.filterFields[key]}&`
                    }
                    else if (key === "division" && this.filterFields[key].length > 0) {

                        this.filterFields[key].map((item, index) => index === 0 ? tags = item : tags += "," + item)
                        url += `${key}=${encodeURIComponent(tags)}&`
                    }
                })
                if (this.sortBy) {
                    url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}&`
                }
                else {
                    url += `sort_field=record_no&sort_order=desc&`
                }
                url += `page=${this.currentPage}&page_size=${this.perPage}`
                const data = await this.getAllCitations(url);
                if (data.total_entries) {
                    this.rows = data.total_entries
                    const start = this.currentPage === 1 ? 1 : (this.perPage * (this.currentPage - 1)) + 1
                    const end = this.perPage * (this.currentPage - 1) + data.queryset_count
                    this.positionText = this.$t('safetyShared.positionText', { start, end, total: data.total_entries })
                }
                else {
                    this.rows = 0
                    this.positionText = this.$t('safetyShared.emptyPosition')
                }
                data.records.map((item) => {
                    this.items.push({
                        id: item.id,
                        driver: item.driver_name ? item.driver_name : '-',
                        record_no: item.record_no,
                        vehicle: item.vehicle_name ? item.vehicle_name : '-',
                        trailer: item.trailer_name ? item.trailer_name : '-',
                        citation_date: item.citation_date ? moment(item.citation_date).format("ll") : '-',
                        citation_number: item.citation_number ? item.citation_number : '-',
                        description: item.description ? item.description : '-',
                        status: item.status,
                        issued_state: item.issued_state ? item.issued_state.name : '-',
                        fine_amount: item.fine_amount ? `$${item.fine_amount}` : '-',
                        out_of_service: item.out_of_service !== null ? item.out_of_service ? this.$t('safetyShared.yes') : this.$t('safetyShared.no') : '-',
                        division: item.division ? item.division_read.division : '-',
                        assigned_to: item.assigned_to ? item.assigned_to_name : '-',
                        court_date: item.court_date ? moment(item.court_date).format("ll") : '-',
                        last_note: item.last_note ? item.last_note.note : '-',
                        outcome: item.outcome ? item.outcome : '-',
                        resolution_date: item.resolution_date ? moment(item.resolution_date).format("ll") : '-',

                    });
                })

                if (this.items.length === 0) this.emptyTable = true
                else this.emptyTable = false
                this.isBusy = false
                this.isTableMounted = true
            }
            catch (e) {
                this.isBusy = false
                this.isTableMounted = true
                console.log(e)
            }
        }
    },
    watch: {
        userPreferences: {
            async handler() {
                if (this.userPreferences) {
                    this.fields = this.userPreferences['Tickets'].sort((a, b) => a.display_order - b.display_order).map((col) => {
                        return { ...col, thClass: 'font-table-weight-bold', ...col.key === 'selected' ? { thStyle: { minWidth: "20px", width: "20px" } } : {} }
                    })
                }
            },
            immediate: true
        },
        perPage: {
            async handler() {
                await this.getCitationData();
            },
            immediate: true,
        },
        currentPage: {
            async handler() {
                await this.getCitationData();
            },
        },
        sortBy: {
            async handler() {
                await this.getCitationData();
            },
        },
        sortDesc: {
            async handler() {
                await this.getCitationData();
            },
        },
        filterFields: {
            handler() {
                this.currentPage = 1
            },
            deep: true
        },
    },
}
</script>